import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormESYEligibilityWorksheet } from "../Models/Forms/IFormESYEligibilityWorksheet";

@Injectable()
export class FormESYEligibilityWorksheetService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormESYEligibilityWorksheet(id: number) {
    return this._http.get(this._baseUrl + "api/FormESYEligibilityWorksheet/" + id)
      .map((response: IFormESYEligibilityWorksheet) => response as IFormESYEligibilityWorksheet)
      .catch(this.errorHandler);
  }

  insertUpdateFormESYEligibilityWorksheet(formESYEligibilityWorksheetDetails: IFormESYEligibilityWorksheet) {
    return this._http.post(this._baseUrl + 'api/FormESYEligibilityWorksheet', formESYEligibilityWorksheetDetails)
      .map((response: IFormESYEligibilityWorksheet) => response as IFormESYEligibilityWorksheet)
      .catch(this.errorHandler);
  }

  deleteESYEligibilityWorksheet(id) {
    return this._http.delete(this._baseUrl + "api/FormESYEligibilityWorksheet/" + id)
      .map((response: IFormESYEligibilityWorksheet) => response as IFormESYEligibilityWorksheet)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}
